@use '@palmetto/palmetto-design-tokens/build/scss/variables-color' as color;

.table {
  td {
    width: auto;
  }
  thead th {
    padding: 12px;
    background: color.$color-brand-grey-100;
  }
  thead th:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    table-layout: auto;
    width: 0px;
    text-transform: none;
  }
  thead th:nth-child(2) {
    padding-left: 0;
  }
  thead th:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  thead,
  thead tr {
    border-radius: 4px;
    background: transparent;
  }
  table {
    background: transparent !important;
  }
  tbody tr:first-child td:first-child {
    border-top-left-radius: 4px;
  }
  tbody tr:first-child td:last-child {
    border-top-right-radius: 4px;
  }
  tbody tr:last-child td:first-child {
    border-bottom-left-radius: 4px;
    min-width: 425px;
  }
  tbody tr:last-child td:last-child {
    border-bottom-right-radius: 4px;
  }
  tbody tr:first-child td > div {
    border: 1px solid var(--color-brand-grey-100);
    border-left-width: 0px !important;
    border-right-width: 0px !important;
    border-top-width: 0px !important;
  }
  tbody tr td:first-child > div {
    margin-left: 12px;
  }
  tbody tr td:last-child > div {
    margin-right: 12px;
  }

  tbody tr td {
    background: #ffffff;
    border: 0px;
    padding: 0px;
  }
  tbody tr td > div {
    padding: 6px;
  }
  tbody:before {
    content: '@';
    display: block;
    line-height: 4px;
    text-indent: -99999px;
  }
}
